import React from "react";

import { StyledContentGrid } from "./MultistepForm.styled";

import { Grid, Skeleton } from "@components/base";

interface MultistepFormSkeleton {}

const MultistepFormSkeleton: React.FC<MultistepFormSkeleton> = () => (
  <Grid container spacing={3} height="calc(100vh - 24px)">
    <Grid size={{ xs: 12, md: 4 }} height="100%" pb={3}>
      <Skeleton variant="rounded" animation="wave" height="100%" />
    </Grid>
    <StyledContentGrid size={{ xs: 12, md: 8 }} pb={3} height="100%">
      <Skeleton variant="rounded" animation="wave" height="100%" />
    </StyledContentGrid>
  </Grid>
);

export default MultistepFormSkeleton;
